var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "36.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 36.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "#003283",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M0 200 l0 -200 125 0 125 0 0 25 0 25 -100 0 -100 0 0 150 0 150 100 0 100 0 0 25 0 25 -125 0 -125 0 0 -200z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M207 313 c-16 -16 -15 -19 15 -50 l32 -33 -82 0 -82 0 0 -30 0 -30 87 0 86 0 -37 -33 -38 -32 25 -23 24 -23 62 69 c33 39 61 74 61 80 0 8 -122 122 -132 122 -2 0 -11 -8 -21 -17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalWhite);
export default __webpack_public_path__ + "static/media/external-white.83d9e8776cd62cc94e3e1836b7009b86.svg";
export { ForwardRef as ReactComponent };